import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { LambdaRoutes } from '../types';

interface Props {
  routes: LambdaRoutes;
  capacityProviderName: Optional<string>;
}

export const CapacityProviderTabs = ({ routes, capacityProviderName }: Props): ReactElement => (
  <NavLink
    to={buildRoute(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDER_FUNCTION_VERSIONS, { name: capacityProviderName })}
    end
  >
    Function Versions
  </NavLink>
);
